import mitt from 'mitt';
import { btnTd } from '@/api/typing';
import defaultSlotList from '@/components/page-model/slotList';
import { reactive } from 'vue';
import {
  delete_order_remove,
  direct_delete_set_record,
  query_person_to_costom_list,
  send_receipt,
} from '@/api/mjstore-model';
import { message, Modal } from 'ant-design-vue';
import modalBox from '@/components/form-modal/modal-tools';

import ls from '@/utils/local-storage';
import { STORAGE_CURRENT_ORG_KEY, STORAGE_CURRENT_SHOP_KEY } from '@/store/mutation-type';
import bus from '@/utils/bus';
const event_bus = bus;
export const event_obj = mitt();
export const btn_list = [
  {
    name: '作废',
    clazz: 'danger',
    is_show: (record: any) => {
      return record.is_delete == false;
    },
    cb: (record: any) => {
      const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org
      const current_shop = ls.get(STORAGE_CURRENT_SHOP_KEY); // 当前门店
      Modal.confirm({
        title: '提示',
        content: `是否作废此项记录`,
        onOk() {
          delete_order_remove({
            org_id: current_org?.id,
            order_remove_id: record.id,
            shop_id: record.shop_id,
            staff_id: record.staff_id,
          }).then((res: any) => {
            if (res.is_confirm) {
              Modal.confirm({
                title: '提示',
                content: res.message,
                onOk() {
                  delete_order_remove({
                    org_id: current_org?.id,
                    order_remove_id: record.id,
                    shop_id: record.shop_id,
                    staff_id: record.staff_id,
                    is_confirm: true,
                  }).then(function () {
                    message.success('作废成功');
                    event_obj.emit('refresh');
                    event_bus.emit('refresh_custom_info', record.customer_id);
                  });
                },
                onCancel() {},
              });
            } else {
              message.success('作废成功');
              event_obj.emit('refresh');
              event_bus.emit('refresh_custom_info', record.customer_id);
            }
          });
        },
        onCancel() {},
      });
    },
  },
  // {
  //   name: '发送',
  //   clazz: 'primary',
  //   content: (record: any) => {
  //     return record.receipt_confirmed ? '已确认' : '发送';
  //   },
  //   disabled: (record: any) => {
  //     return !!record.receipt_confirmed;
  //   },
  //   cb: (record: any) => {
  //     const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org
  //     query_person_to_costom_list({
  //       org_id: current_org?.id,
  //       customer_id: record.customer_id,
  //     }).then((res: any) => {
  //       if (res.data.length == 0 || (res.data.length > 0 && !res.data[0].name)) {
  //         Modal.warning({
  //           title: '提示',
  //           content: '会员尚未绑定，无法发送',
  //         });
  //       } else {
  //         Modal.confirm({
  //           title: '提示',
  //           content: `即将发送撤单记录至客户公众号账号，是否继续发送（第${
  //             record.receipt_count + 1
  //           }次发送）`,
  //           onOk() {
  //             send_receipt({
  //               obj_id: record.id,
  //               business_type: 'OrderRemove',
  //               org_id: current_org?.id,
  //             }).then(res => {
  //               message.success('发送成功');
  //               Object.assign(record, res);
  //             });
  //           },
  //           onCancel() {},
  //         });
  //       }
  //     });
  //   },
  // },
];
export const slotList = defaultSlotList;
export const config = {
  creatCol: [6, 7],
  updateCol: [],
};

export const head_btn_list = [
  // {
  //   name: '导出',
  //   clazz: 'primary',
  //   cb: (search_model: any) => {
  //     const current_org = ls.get(STORAGE_CURRENT_ORG_KEY);
  //     const payload: any = {
  //       org_id: current_org?.id,
  //       ...search_model,
  //     };
  //     let params_str = '';
  //     Object.keys(payload).forEach(key => {
  //       if (payload[key] != null && key != 'current' && key != 'pageSize') {
  //         params_str += key + '=' + payload[key] + '&';
  //       }
  //     });
  //     window.open(
  //       '/mjstore/query_order_remove_list?export=true&' + params_str + new Date().getTime(),
  //       '_blank',
  //     );
  //     message.success('导出成功');
  //   },
  // },
];
